import React, { useState, useEffect } from "react";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import { Collapse, Form, Switch } from "antd";
import { getRequest } from "../../axios";
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';

const PermissionPanelStep = ({ appLabel, modelName, permissions, state, setState, groupId, index, CompanyId, vendorId }) => {
  const { t } = useTranslation();
  const [permissionData, setPermissionData] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const { Panel } = Collapse;
   // console.log("CompanyId", CompanyId);
   // console.log("vendorId", vendorId);
  useEffect(() => {
    const allChecked = permissionData.every(permission => permission.is_checked);
    setSelectAll(allChecked);
  }, [permissionData]);

  const PRApprovalHierarchyGetById = async () => {
    try {
      let apiResponse;
      if (groupId !== null && groupId !== undefined) {
          if (CompanyId !== null && CompanyId !== undefined) {
              apiResponse = await getRequest(`list-permission/get-purticlare-permission/?content_types=${appLabel}&model_names=${modelName}&group_id=${groupId}&company_id=${CompanyId}`);
          } else if (vendorId !== null && vendorId !== undefined) {
              apiResponse = await getRequest(`list-permission/get-purticlare-permission/?content_types=${appLabel}&model_names=${modelName}&group_id=${groupId}&vendor_id=${vendorId}`);
          } else {
              apiResponse = await getRequest(`list-permission/get-purticlare-permission/?content_types=${appLabel}&model_names=${modelName}&group_id=${groupId}`);
          }
      } else {
        if (CompanyId !== null && CompanyId !== undefined) {
            apiResponse = await getRequest(`list-permission/get-purticlare-permission/?content_types=${appLabel}&model_names=${modelName}&company_id=${CompanyId}`);
        } else if (vendorId !== null && vendorId !== undefined) {
            apiResponse = await getRequest(`list-permission/get-purticlare-permission/?content_types=${appLabel}&model_names=${modelName}&vendor_id=${vendorId}`);
        } else {
            apiResponse = await getRequest(`list-permission/get-purticlare-permission/?content_types=${appLabel}&model_names=${modelName}`);
        }

      }
      if (apiResponse.data.success) {
        const modifiedPermissions = apiResponse.data.data.map(permission => ({
          ...permission,
          is_checked: apiResponse.data.data.some(p => p.id === permission.id && p.is_checked)
        }));
         //console.log("modifiedPermissions", modifiedPermissions);
        setPermissionData(modifiedPermissions);
      } else {
        ErrorNotificationMsg(t("error_in_list_prapproval_hierarchy"));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    PRApprovalHierarchyGetById();
  }, []);

  const handleSwitchChange = (checked, permissionId) => {
    const updatedPermissionData = permissionData.map(permission => {
      if (permission.id === permissionId) {
        return { ...permission, is_checked: checked };
      }
      return permission;
    });
    setPermissionData(updatedPermissionData);

    const selectedPermissions = updatedPermissionData.filter(permission => permission.is_checked).map(permission => permission.id);

    setState(prevState => ({
      ...prevState,
      permissions: checked
        ? [...new Set([...prevState.permissions, ...selectedPermissions])]
        : prevState.permissions.filter(id => id !== permissionId)
    }));
  };

  const handleSelectAllChange = (checked) => {
    setSelectAll(checked);
    const updatedPermissionData = permissionData.map(permission => ({
      ...permission,
      is_checked: checked
    }));
    setPermissionData(updatedPermissionData);

    const selectedPermissions = updatedPermissionData.filter(permission => permission.is_checked).map(permission => permission.id);

    setState(prevState => ({
      ...prevState,
      permissions: checked
        ? [...new Set([...prevState.permissions, ...selectedPermissions])]
        : prevState.permissions.filter(id => !permissionData.some(permission => permission.id === id))
    }));
  };
  const onChange = (activeKey) => {
    if (activeKey && activeKey.includes(index)) {
      PRApprovalHierarchyGetById();
    }
  };

    const stringMap = {
        activitylog: "Activity log",
        attachment: "Attachment",
        company: "Company",
        employee: "Employee",
        user: "User",
        vendor: "Vendor",
        pincode: "Pincode",
        categorytree: "Category tree",
        addressmaster: "Address Master",
        wbsnumber: "WBS Master",
        businesssetting: "Business Setting",
        bankdetails: "Bank Details",
        keypersons: "Key Persons",
        customgroup: "Custom Group",
        materialmaster: "Material Master",
        materialtype: "Material Type",
        requestdemo: "Request Demo",
        unitofmeasurements: "Unit Of Measurements",
        zonename: "Zone Name",
        purchaserequisitiondetails: "Purchase Requisition Details",
        purchaserequisitionmaster: "Purchase Requisition Master",
        purchaserequisitionsite: "Purchase Requisition Site",
        floatrfq: "Float RFQ",
        rfq: "RFQ",
        rfqmaterialdetail: "RFQ Material Detail",
        rfqvendordetail: "RFQ Vendor Detail",
        bidrfq: "Bid RFQ",
        poorder: "PO Order",
        subscriptionfeature: "Subscription Feature",
        subscriptioninvoice: "Subscription Invoice",
        subcription: "Subscription",
        stripecharge: "Stripe Charge",
        prrelease: "PR Release",
        authgrouppermissionsmodel: "Auth Group Permission",
        vendorcompany: "Vendor Company",
        vendorcompanycode: "Vendor Company Code",
        vendorinquiryvalue: "Vendor Inquiry Value",
        assigncitytovendor: "Assign City to Vendor",
        vendorsuppliersbillingdetails: "Vendor Suppliers Billing Details",
        vendorpaymentreleased: "Vendor Payment Released",
        vendorcommunicationmatrix: "Vendor Communication Matrix",
    };
  function toCapitalCase(str) {
    console.log()
      return stringMap[str] || str;
  }

  return (
    <Collapse defaultActiveKey={['']} onChange={onChange}>
      <Panel key={index} header={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
           {toCapitalCase(modelName)}
          <div style={{ display: 'flex', alignItems: 'center', marginRight: '30px' }}>

            <div onClick={(e) => e.stopPropagation()}>
              <Switch
                checked={selectAll}
                onChange={handleSelectAllChange}
              />
            </div>
            <span style={{ marginLeft: 10, fontWeight: '600' }}>Select All</span>
          </div>
        </div>
      }>
        {permissionData.map(permission => {
          
          return (
          <div key={permission.id} className="permissionlist TextFeild">

            <Form.Item className="radioitem">
              <div onClick={(e) => e.stopPropagation()}>
                <Switch
                  checked={permission.is_checked}
                  onChange={(checked) => handleSwitchChange(checked, permission.id)}
                />
              </div>
            </Form.Item>
            {permission.name}
          </div>
        )}
        )}
      </Panel>
    </Collapse>
  );
};

PermissionPanelStep.propTypes = {
  appLabel: PropTypes.number.isRequired,
  modelName: PropTypes.string.isRequired,
  permissions: PropTypes.array,
  state: PropTypes.object,
  setState: PropTypes.func.isRequired,
  groupId: PropTypes.number,
  index: PropTypes.number,
  CompanyId: PropTypes.number,
  vendorId: PropTypes.number
};

export default PermissionPanelStep;
